import { SlidersHorizontal } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ControlsIcon = DeckardIconWrapper({ Icon: SlidersHorizontal });
